import { render, staticRenderFns } from "./payment_reminders.vue?vue&type=template&id=251c94e0"
import script from "./payment_reminders.vue?vue&type=script&lang=js"
export * from "./payment_reminders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports